import { Component, OnInit } from '@angular/core';
import {
  ColDef, ColumnApi,
  GetContextMenuItemsParams, GridApi,
  GridReadyEvent, IFilterOptionDef,
  IServerSideGetRowsParams, RowClassRules,
  RowNode,
  SetFilterValuesFuncParams, ValueSetterParams
} from 'ag-grid-community';
import {SharedService} from '../../services/shared.service';
import {environment} from '../../../environments/environment';
import {HttpService} from '../../services/http.service';
import {GridService} from '../../services/grid.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {SkuComponent} from '../cell/sku/sku.component';
import {CellEditorBrandComponent} from '../cell-editors/cell-editor-brand/cell-editor-brand.component';
import {CellEditorTypeComponent} from '../cell-editors/cell-editor-type/cell-editor-type.component';
import {CellEditorTagsComponent} from '../cell-editors/cell-editor-tags/cell-editor-tags.component';
import {TagsCustomFilterComponent} from '../filter/tags-custom-filter/tags-custom-filter.component';
import {StorageService} from '../../services/storage.service';
import {HistoryDialogComponent} from '../dialogs/history-dialog/history-dialog.component';
import {
  CellHistoryRestoreButtonComponent
} from '../cell-editors/cell-history-restore-button/cell-history-restore-button.component';
import {AiPushToLearnModelComponent} from '../cell/ai-push-to-learn-model/ai-push-to-learn-model.component';
import {AiLearnDataActionsComponent} from '../cell/ai-learn-data-actions/ai-learn-data-actions.component';
import {AiFineTuneGptActionsComponent} from '../cell/ai-fine-tune-gpt-actions/ai-fine-tune-gpt-actions.component';
import {ToastService} from '../../services/toast.service';
import {Router} from '@angular/router';
import {AiStepDetailsDialogComponent} from '../dialogs/ai-step-details-dialog/ai-step-details-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {AiTuneSettingsDialogComponent} from '../dialogs/ai-tune-settings-dialog/ai-tune-settings-dialog.component';
import {AiReportDialogComponent} from '../../components/dialog/ai-report-dialog/ai-report-dialog.component';

@Component({
  selector: 'app-grid-fine-tuning',
  templateUrl: './grid-fine-tuning.component.html',
  styleUrls: ['./grid-fine-tuning.component.scss']
})
export class GridFineTuningComponent implements OnInit {
  public readonly statusBar = {
    statusPanels: [{ statusPanel: 'agSelectedRowCountComponent' }]
  };
  public readonly autoGroupColumnDef: ColDef = {minWidth: 200,}
  public readonly sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
        }
      },
      // https://www.ag-grid.com/angular-data-grid/component-tool-panel/
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        toolPanelParams: {
          suppressExpandAll: false,
          suppressFilterSearch: false
        }
      },
    ],
  };
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    sortable: true,
    editable: true,
    filter: true,
    // floatingFilter: true,
    resizable: true,
    // menuTabs: ['filterMenuTab', 'generalMenuTab'],
    filterParams: {
      buttons: ['reset'],
    },
    cellRenderer: (cell: any) => {
      if (!['tags', 'vendor_tags'].includes(cell.colDef.field)) {
        return cell.value;
      }
    },
  };
  public containsFilterParams = {
    suppressAndOrCondition: true,
    debounceMs: 400,
    filterOptions: [
      'equals',
      'contains',
      'notContains',
      'notEqual',
      'startsWith',
      {
        displayKey: 'notStartsWith',
        displayName: 'Does not start with',
        predicate: (_, cellValue) => {
          return true;
        },
        numberOfInputs: 1,
      },
      'endsWith',
      {
        displayKey: 'notEndsWith',
        displayName: 'Does not end with',
        predicate: (_, cellValue) => {
          return true;
        },
        numberOfInputs: 1,
      },
      'blank',
      'notBlank',
    ] as IFilterOptionDef[]
  };
  public rowClassRules: RowClassRules = {
    'ai-learn-duplicate-record': (params) => {
      if (params.data && params.data.duplicate) {
        return true
      } else {
        return false;
      }
    }
  };
  public showLearnData: boolean = true;
  // public columnDefs: ColDef[] = this.sharedService.columnDefs;
  public columnDefs: any = [
    {
      field: '_id',
      headerName: 'id',
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'product_id',
      headerName: 'Product ID',
      filter: 'agTextColumnFilter',
      hide: true,
      floatingFilter: true,
      // checkboxSelection: true,
      // pinned: 'left',
      minWidth: 250,
      editable: false,
      filterParams: {
        suppressAndOrCondition: true,
      },
    },
    {
      field: 'sku',
      headerName: 'SKU',
      filter: 'agTextColumnFilter',
      pinned: true,
      // hide: true,
      checkboxSelection: true,
      minWidth: 200,
      editable: false,
      floatingFilter: true,
      // sort: 'asc',
      filterParams: this.containsFilterParams,
      // filterParams: {
      //   debounceMs: 400,
      //   suppressAndOrCondition: true,
      // },
      cellRenderer: SkuComponent
    },
    {
      field: 'handle',
      headerName: 'Handle',
      editable: false,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: this.containsFilterParams,
      minWidth: 250,
    },
    {
      field: 'shopify_published',
      headerName: 'Shopify Published',
      editable: false,
      hide: true,
      // filter: true,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        suppressSorting: true,
        valueFormatter: (cell: any) => {
          return cell.value && cell.value === 'true' ? 'true' : 'false';
        }
      },
      cellRenderer: (cell: any) => {
        return +cell.data.shopify_published === 1;
      }
    },
    {
      field: 'brand',
      headerName: 'Brand',
      maxWidth: 135,
      cellRenderer: (cell: any) => {
        return cell.value?.name;
      },
      editable: false,
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.brands.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.brands.find(b => b._id === cell.value)) {
            return this.storageService.brands.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      }
    },
    {
      field: 'type',
      headerName: 'Type',
      // hide: true,
      minWidth: 120,
      editable: false,
      cellRenderer: (cell: any) => {
        // console.log('🔴', cell);
        // return this.storageService.types.find(b => b._id === cell.value._id) ? this.storageService.types.find(b => b._id === cell.value._id).name : null;
        return cell.value?.name;
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.types.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.types.find(b => b._id === cell.value)) {
            return this.storageService.types.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      }
    },
    {
      field: 'tags',
      headerName: 'Tags',
      minWidth: 400,
      hide: true,
      editable: false,
      suppressFiltersToolPanel: true,
      cellRenderer: (cell: any) => {
        let tags: any = [];
        cell.value?.forEach((tag: any) => {
          const name = this.storageService.tagMap.get(tag._id);
          if (name) {
            tags.push(name);
          }
        });
        return tags.join(', ');
      },
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      }
    },
    {
      field:'opa1',
      headerName: 'Description',
      minWidth: 1500,
      editable: false,
      suppressFiltersToolPanel: true,
      cellRenderer: (params: any) => {
        // console.log(params);
        const row = params.data;
        const regex = /<[^>]+>/g;
        const body_seo = row.body_seo
          .replace(regex, ' ')
          .replace('Resources', '')
          .replace('More Info', '')
          .replace('See catalog product page for full listing', '')
          .replace(/ {2}/g, ' ')
          .replace(/ {3}/g, ' ')
          .replace(/ {4}/g, ' ')
          .trim();

        const body_prefix_1 = row.body_prefix_1.replace(regex, ' ').replace('See catalog product page for full listing', '').replace('Resources', '').replace('More Info', '').replace(/ +/g, " ").trim();
        const body_prefix_2 = row.body_prefix_2.replace(regex, ' ').replace('See catalog product page for full listing', '').replace('Resources', '').replace('More Info', '').replace(/ +/g, " ").trim();
        const body_prefix_3 = row.body_prefix_3.replace(regex, ' ').replace('See catalog product page for full listing', '').replace('Resources', '').replace('More Info', '').replace(/ +/g, " ").trim();

        const body_suffix_1 = row.body_suffix_1.replace(regex, ' ').replace('See catalog product page for full listing', '').replace('Resources', '').replace('More Info', '').replace(/ +/g, " ").trim();
        const body_suffix_2 = row.body_suffix_2.replace(regex, ' ').replace('See catalog product page for full listing', '').replace('Resources', '').replace('More Info', '').replace(/ +/g, " ").trim();
        const body_suffix_3 = row.body_suffix_3.replace(regex, ' ').replace('See catalog product page for full listing', '').replace('Resources', '').replace('More Info', '').replace(/ +/g, " ").trim();

        const body: string = body_prefix_1 + ' ' + body_prefix_2 + ' ' + body_prefix_3 + ' ' + body_seo + ' ' + body_suffix_1 + ' ' + body_suffix_2 + ' ' + body_suffix_3;

        if (body.length > row.description.length) {
          return body.trim();
        } else {
          return row.description;
        }
        // return body.trim().length > 2 ? body : row.description;
      }
      // cellRenderer: (params: any) => {
      //   const product = params.data;
      //   const body = product.body_seo.toLowerCase() + product.body_prefix_1.toLowerCase() + product.body_prefix_2.toLowerCase() + product.body_prefix_3.toLowerCase() + product.body_suffix_1.toLowerCase() + product.body_suffix_2.toLowerCase() + product.body_suffix_3.toLowerCase();
      //   const description = product.description.toLowerCase();
      //   const sku = product.sku.toLowerCase();
      //   const brand = product.brand.name.toLowerCase();
      //
      //   const regex = /<[^>]+>/g;
      //   const bodyClean = body
      //     .replace(regex, '')
      //     .replaceAll(sku, '')
      //     .replaceAll(brand, '')
      //     .replaceAll('|', '')
      //     .replaceAll('--', '')
      //     .replaceAll('^', '')
      //     .replace('Resources', '')
      //     .replace('More Info', '')
      //     .replace('See catalog product page for full listing', '')
      //     .replaceAll(';', '')
      //     .replaceAll(' ', '')
      //     .replace(/ +/g, '').trim();
      //
      //   return bodyClean;
      // }
    },
    {
      field: 'action',
      maxWidth: 120,
      minWidth: 100,
      headerName: '',
      pinned: 'right',
      editable: false,
      disabled: true,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      cellClass: ['history-dialog-action-cell'],
      cellRenderer: AiPushToLearnModelComponent
    }
  ];
  public columnDefsGptResult: any = [
    {
      field: '_id',
      headerName: 'id',
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'product_id',
      headerName: 'Product ID',
      filter: 'agTextColumnFilter',
      hide: true,
      checkboxSelection: false,
      pinned: 'left',
      minWidth: 250,
      editable: false,
      filterParams: {
        suppressAndOrCondition: true,
      },
    },
    {
      field: 'sku',
      headerName: 'SKU',
      editable: false,
      checkboxSelection: true,
      // pinned: true,
      pinned: 'left',
      // hide: true,
      minWidth: 200,
      // sort: 'asc',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: {
        debounceMs: 400,
        suppressAndOrCondition: true,
      },
      cellRenderer: SkuComponent
    },
    {
      field: 'description',
      editable: false,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      field: 'structure',
      editable: false,
      maxWidth: 550,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      field: 'action',
      maxWidth: 130,
      minWidth: 100,
      editable: false,
      headerName: '',
      pinned: 'right',
      disabled: true,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      cellClass: ['history-dialog-action-cell'],
      cellRenderer: AiFineTuneGptActionsComponent
    },
    {
      field: 'updated_at',
      hide: true,
      suppressFiltersToolPanel: true,
      sort: 'desc'
    },
  ];
  public columnDefsLearnFields: any = [
    {
      field: '_id',
      headerName: 'id',
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field:'description',
      headerName: 'Description',
      minWidth: 500,
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
      suppressFiltersToolPanel: true,
    },
    {
      field:'structure',
      headerName: 'Structure',
      maxWidth: 600,
      editable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: 200000,
        rows: 10,
        cols: 50
      },
      suppressFiltersToolPanel: true,
    },
    {
      field: 'created_at',
      hide: true,
      suppressFiltersToolPanel: true,
      // sort: 'asc'
    },
    {
      field: 'updated_at',
      hide: true,
      suppressFiltersToolPanel: true,
      sort: 'desc'
    },
    {
      field: '',
      suppressFiltersToolPanel: true,
      editable: false,
      maxWidth: 77,
      cellRenderer: AiLearnDataActionsComponent,
      pinned: 'right',
    }
  ];

  public disableCompareFileBtn = false;
  public disableTuneFileBtn = false;

  public selectedItemsCount = 0;
  public filterIsActive = false;

  public mainGridApi: GridApi | undefined;
  public mainGridColumnApi: ColumnApi | undefined;

  public learnDataGridApi: GridApi | undefined;
  public learnDataGridColumnApi: ColumnApi | undefined;

  public gptResultGridApi: GridApi | undefined;
  public gptResultGridColumnApi: ColumnApi | undefined;
  public gptInWorking = false;
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private sharedService: SharedService,
    private storageService: StorageService,
    private httpService: HttpService,
    private gridService: GridService,
    private toastService: ToastService,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit(): void {
    this.gridService.aiFineTuneGptCompleteAllEvent.subscribe(resp => {
      if (resp) {
        this.gptInWorking = false;
      }
    });
    this.gridService.aiFineTuneGptCompleteEvent.subscribe(resp => {
      if (resp) {
        this.gptResultGridApi?.refreshServerSide();
      }
    });
    this.gridService.aiLearGridEvent.subscribe(resp => {
      if (resp) {
        this.learnDataGridApi?.refreshServerSide();
      }
    });
  }

  onGridReady(params: GridReadyEvent) {
    this.mainGridApi = params.api;
    this.mainGridColumnApi = params.columnApi;
    const that = this;

    this.mainGridApi.setFilterModel({
      shopify_published: {
        filterType: 'set',
        values: ['true']
      },
    });

    this.mainGridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;
        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        that.httpService.post(environment.API_PATH + '/product/stage', body).subscribe((dataAndCount) => {
          const receivedData = dataAndCount as { rows: {}[], count: number };
          params.success({
            rowData: receivedData.rows,
            rowCount: receivedData.count
          });
        });
      }
    });
  }

  onGptResultGridReady(params: GridReadyEvent) {
    this.gptResultGridApi = params.api;
    this.gptResultGridColumnApi = params.columnApi;
    const that = this;

    this.gptResultGridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;
        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        that.httpService.post(environment.API_PATH + '/ai/gptResultsData', body).subscribe((dataAndCount) => {
          const receivedData = dataAndCount as { rows: {}[], count: number };
          params.success({
            rowData: receivedData.rows,
            rowCount: receivedData.count
          });
        });
      }
    });
  }

  onLearnDataGridReady(params: GridReadyEvent) {
    this.learnDataGridApi = params.api;
    this.learnDataGridColumnApi = params.columnApi;
    const that = this;

    this.learnDataGridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;
        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        that.httpService.post(environment.API_PATH + '/ai/learnData', body).subscribe((dataAndCount) => {
          const receivedData = dataAndCount as { rows: {}[], count: number };
          params.success({
            rowData: receivedData.rows,
            rowCount: receivedData.count
          });
        });
      }
    });
  }

  getContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [
      {
        name: 'Open Shopify Page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
    ];
  }

  getGptContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [
      {
        name: 'Open Shopify page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      {
        name: 'Show selected in main grid',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          const selectedRows: any = this.gptResultGridApi?.getSelectedRows();
          if (selectedRows) {
            const ids = selectedRows.map((row: any) => row.product_id);
            console.log('ids', ids);
            this.mainGridApi?.setFilterModel({
              product_id: {
                filterType: 'text',
                type: ids.length > 1 ? 'contains' : 'equals',
                filter: selectedRows.map((row: any) => row.product_id)
              }
            });
          }
        }
      },
      'separator',
      {
        name: 'Push selected records',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-menu" unselectable="on" role="presentation"></span>',
        action: () => {
          this.pushSelectedGptResultRecords();
        }
      },
      {
        name: 'Restart selected records',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-grip" unselectable="on" role="presentation"></span>',
        action: () => {
          this.restartSelectedGptResultRecords();
        }
      },
      'export',
      'separator',
      {
        name: 'Delete selected records',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-cross" unselectable="on" role="presentation"></span>',
        action: () => {
          this.deleteSelectedGptResultRecords();
        }
      }
    ];
  }


  getLearnDataContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [
      {
        name: 'New item',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-menu" unselectable="on" role="presentation"></span>',
        action: () => {
          this.addNewLearnDataItem();
        }
      },
      'export',
      'separator',
      {
        name: 'Delete selected records',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-cross" unselectable="on" role="presentation"></span>',
        action: () => {
          this.deleteSelectedLearnDataRecords();
        }
      },
    ];
  }

  getBlankContextMenuItems = (params: GetContextMenuItemsParams) => {
    return ['separator'];
  }

  deleteSelectedLearnDataRecords() {
    const selectedRows: any = this.learnDataGridApi?.getSelectedRows();
    if (selectedRows) {
      const ids = selectedRows.map((row: any) => row._id);
      if (confirm('Are you sure?')) {
        this.learnDataGridApi?.clearRangeSelection();
        this.httpService.post(environment.API_PATH + `/ai/deleteSelectedLearnData`, {ids: ids}).subscribe(res => {
          this.gridService.aiLearGridEvent.next(true);
        });
      }
    }
  }

  restartSelectedGptResultRecords() {
    const selectedRows: any = this.gptResultGridApi?.getSelectedRows();
    if (selectedRows) {
      const ids = selectedRows.map((row: any) => row._id);
      console.log('restartSelectedGptResultRecords', ids);
      if (confirm('Are you sure?')) {
        this.gptResultGridApi?.clearRangeSelection();
        this.httpService.post(environment.API_PATH + `/ai/restartSelectedGptFineTuneModel`, {ids: ids}).subscribe(res => {
          this.gridService.aiFineTuneGptCompleteEvent.next(true);
        });
      }
    }
  }
  pushSelectedGptResultRecords() {
    const selectedRows: any = this.gptResultGridApi?.getSelectedRows();
    if (selectedRows) {
      const ids = selectedRows.map((row: any) => row._id);
      if (confirm('Are you sure?')) {
        this.gptResultGridApi?.clearRangeSelection();
        this.httpService.post(environment.API_PATH + `/ai/pushSelectedGptResultRecords`, {ids: ids}).subscribe(res => {
          this.gridService.aiFineTuneGptCompleteEvent.next(true);
          this.gridService.aiLearGridEvent.next(true);
        });
      }
    }
  }
  deleteSelectedGptResultRecords() {
    const selectedRows: any = this.gptResultGridApi?.getSelectedRows();
    if (selectedRows) {
      const ids = selectedRows.map((row: any) => row._id);
      if (confirm('Are you sure?')) {
        this.gptResultGridApi?.clearRangeSelection();
        this.httpService.post(environment.API_PATH + `/ai/deleteSelectedGptResultsData`, {ids: ids}).subscribe(res => {
          this.gridService.aiFineTuneGptCompleteEvent.next(true);
        });
      }
    }
  }

  addNewLearnDataItem() {
    this.httpService.post(environment.API_PATH + `/ai/createNewLearnDataItem`, {}).subscribe(res => {
      this.gridService.aiLearGridEvent.next(true);
    });
  }
  onSelectionChanged($event: any): void {
    console.log('123');
    // const selectedRows: any = this.gridService.gridApi?.getSelectedRows();
    // this.selectedItemsCount = selectedRows.length;
    // this.gridService.stageSelectedItemsCount$.next(selectedRows.length);
    // console.log('🤲 selectedRows', selectedRows);
    // this.gridService.gridApi?.getSelectedNodes().forEach((rowNode: RowNode) => {
    //   if (rowNode.data.locked && rowNode.data.locked.user) {
    //     rowNode.setSelected(false);
    //   }
    // });
  }

  cellValueChanged($event: any): void {
    console.log($event);
    this.httpService.patch(environment.API_PATH + '/ai/learnData', {payload: $event.data}).subscribe(resp => {
      // this.toastService.success(resp.message);
    });
  }

  filterChanged($event: any): void {
    const filterModel = this.gridService.gridApi?.getFilterModel();
    this.localStorageService.setItem('stageFilterModel', filterModel);
    this.gridService.stageFilterIsActive$.next(!!(filterModel && Object.keys(filterModel).length));
    this.filterIsActive = !!(filterModel && Object.keys(filterModel).length);
  }

  aiSettings() {
    this.dialog.open(AiTuneSettingsDialogComponent, {
      autoFocus: false,
      data: {}
    });
  }
  getRandomProducts() {
    this.mainGridApi?.showLoadingOverlay();
    const settings = this.localStorageService.getItem('ai_tune_settings');
    this.httpService.post(environment.API_PATH + '/ai/getRandomProducts', {
      minL: settings.min_length || 1,
      maxL: settings.max_length || 20,
      count: settings.count || 10
    }).subscribe(response => {
      this.mainGridApi?.setFilterModel({
        _id: {
          filterType: 'text',
          type: 'contains',
          filter: response.ids
        }
      });
      setTimeout(() => {
        this.mainGridApi?.hideOverlay();
      }, 700);
    });
  }
  filterReset() {
    this.mainGridApi?.setFilterModel({
      shopify_published: {
        filterType: 'set',
        values: ['true']
      },
    });
  }

  getGptLastUpdate() {
    this.dialog.open(AiReportDialogComponent, {
      width: '90%',
      maxWidth: '1024px',
      disableClose: true,
    });
  }

  showTreeData() {
    this.router.navigate(['ai/tree']);
  }

  getCompareFile() {
    if (confirm('Are you sure?')) {
      this.disableCompareFileBtn = true;
      this.toastService.info('Please wait...');
      this.httpService.post(environment.API_PATH + '/ai/generateCompareFile', {}).subscribe(response => {
        this.toastService.success(`<a target="_blank" href="${environment.API_PATH + response.filePath}">Click here</a> to download the file.`,'Compare file', {
          disableTimeOut: true,
          enableHtml: true
        });
        this.disableCompareFileBtn = false;
      });
    }
  }

  getFineTuneFile() {
    this.disableTuneFileBtn = true;
    this.httpService.post(environment.API_PATH + '/ai/makeLearnData', {}).subscribe(response => {
      this.toastService.success(`<a target="_blank" href="${environment.API_PATH + response.filePath}">Click here</a> to download the file.`, '', {
        disableTimeOut: true,
        enableHtml: true
      });
      this.disableTuneFileBtn = false;
    });
  }
  gptStop() {
    this.httpService.post(environment.API_PATH + '/ai/stopGptWork', {}).subscribe(response => {
      this.gptInWorking = !this.gptInWorking;
    });
  }
  parserSelected() {
    const selectedRows: any = this.mainGridApi?.getSelectedRows();
    console.log('selected rows:', selectedRows);
    if (selectedRows) {
      this.gptInWorking = !this.gptInWorking;
      const ids = selectedRows.map((row: any) => row.product_id);
      this.httpService.post(environment.API_PATH + '/ai/startSelectedGptFineTuneModel', {ids}).subscribe(response => {});
    }
  }

  parserFilered() {
    const filterModel = this.mainGridApi?.getFilterModel();
    if (confirm('Are you sure?')) {
      this.submitAction(filterModel);
    }
  }

  private submitAction(filterModel: any): void {
    const body = { startRow: 0, endRow: 100, filterModel };
    this.gptInWorking = !this.gptInWorking;
    this.httpService.post(environment.API_PATH + '/ai/startFilteredGptFineTuneModel', body).subscribe(response => {});
  }
}
